import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/extends";
import _objectSpread2 from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { deepMapKeysToCamelCase, deepMapKeysToSnakeCase
/* eslint "@typescript-eslint/ban-ts-comment": 1 */
// @ts-ignore: not yet implemented
} from '@appfolio/js-data-mapper';
import qs from 'qs';
var HOSTNAME = "".concat(window.location.protocol, "//").concat(window.location.host);
var HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest' // make backwards compatible with rails "request.xhr?"

};

function href(path) {
  return path.match(/^http/) ? path : "".concat(HOSTNAME).concat(path);
}
/**
 * Refer to: https://github.com/ljharb/qs#stringifying
 */


export function serialize(obj, options) {
  return qs.stringify(obj, options);
}
/**
 * Checks the response code of an HTTP response.
 * For 200 responses a Promise for the JSON is returned.  Otherwise an error is thrown
 */

function checkResponseStatus(_x) {
  return _checkResponseStatus.apply(this, arguments);
}

function _checkResponseStatus() {
  _checkResponseStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
    var status;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            status = res.status;

            if (!(status === 204)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", Promise.resolve());

          case 5:
            if (!(status === 302)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", Promise.reject(res));

          case 9:
            if (!(status === 401 || status === 403)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", Promise.reject(res));

          case 13:
            if (!(status < 200 || status >= 300)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", res.text().then(function (text) {
              var data = {};

              try {
                data = JSON.parse(text);
              } catch (e) {} // eslint-disable-line no-empty


              var error = new Error(!data && text || res.statusText);
              error.data = deepMapKeysToCamelCase(data);
              error.status = status;
              throw error;
            }));

          case 15:
            _context.prev = 15;
            _context.next = 18;
            return res.json();

          case 18:
            return _context.abrupt("return", _context.sent);

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](15);
            return _context.abrupt("return", Promise.resolve());

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[15, 21]]);
  }));
  return _checkResponseStatus.apply(this, arguments);
}

var shouldConvertResponseCase = function shouldConvertResponseCase(options) {
  if (Object.prototype.hasOwnProperty.call(options, 'convertCase')) {
    return options.convertCase;
  }

  if (Object.prototype.hasOwnProperty.call(options, 'convertResponseCase')) {
    return options.convertResponseCase;
  }

  return true;
};

var shouldConvertRequestCase = function shouldConvertRequestCase(options) {
  if (Object.prototype.hasOwnProperty.call(options, 'convertRequestCase')) {
    return options.convertRequestCase;
  }

  return true;
}; // Used for converting case for all API METHODS


var convertResponseCase = function convertResponseCase(options, result) {
  if (shouldConvertResponseCase(options)) return deepMapKeysToCamelCase(result);
  return result;
};

var getRequestParams = function getRequestParams(options, params) {
  if (shouldConvertRequestCase(options)) {
    return deepMapKeysToSnakeCase(params);
  }

  return params;
};
/**
 * Perform an HTTP GET to the API and parse the response as JSON
 */


export function get(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    convertCase: true,
    // deprecated
    convertResponseCase: true,
    convertRequestCase: true,
    serializeOptions: {}
  };
  var serializeOptions = Object.prototype.hasOwnProperty.call(options, 'serializeOptions') ? options.serializeOptions : {};

  var headers = _objectSpread2(_objectSpread2({}, HEADERS), options.headers);

  var url = href(path);
  var getParams = getRequestParams(options, params);

  if (params && Object.keys(params).length) {
    var allSerializeOptions = _extends({
      encodeValuesOnly: true,
      arrayFormat: 'brackets'
    }, serializeOptions);

    url = "".concat(url, "?").concat(serialize(getParams, allSerializeOptions));
  }

  var promise = fetch(url, {
    credentials: options.credentials || 'same-origin',
    headers: headers
  });
  return promise.then(function (response) {
    return checkResponseStatus(response).then(function (result) {
      return convertResponseCase(options, result);
    }).then(function (data) {
      return {
        data: data,
        response: response
      };
    });
  });
}
/**
 * Perform an HTTP POST to the API and parse the response as JSON
 */

export function post(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    convertCase: true,
    // deprecated
    convertResponseCase: true,
    convertRequestCase: true
  };

  var headers = _objectSpread2(_objectSpread2({}, HEADERS), options.headers);

  var postParams = getRequestParams(options, body);
  var newBody;

  if (body instanceof FormData) {
    delete headers['Content-Type'];
    newBody = body;
  } else {
    newBody = JSON.stringify(postParams);
  }

  var promise = fetch(href(path), {
    body: newBody,
    credentials: options.credentials || 'same-origin',
    headers: headers,
    method: 'POST'
  });
  return promise.then(function (response) {
    return checkResponseStatus(response).then(function (result) {
      return convertResponseCase(options, result);
    }).then(function (data) {
      return {
        data: data,
        response: response
      };
    });
  });
}
/**
 * Perform an HTTP PUT to the API and parse the response as JSON
 */

export function put(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    convertCase: true,
    // deprecated
    convertResponseCase: true,
    convertRequestCase: true
  };
  var putParams = getRequestParams(options, body);

  var headers = _objectSpread2(_objectSpread2({}, HEADERS), options.headers);

  var promise = fetch(href(path), {
    body: JSON.stringify(putParams),
    credentials: options.credentials || 'same-origin',
    headers: headers,
    method: 'PUT'
  });
  return promise.then(function (response) {
    return checkResponseStatus(response).then(function (result) {
      return convertResponseCase(options, result);
    }).then(function (data) {
      return {
        data: data,
        response: response
      };
    });
  });
}
/**
 * Perform an HTTP DELETE to the API
 */

export function del(path, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    convertCase: true,
    convertResponseCase: true,
    convertRequestCase: true
  };

  var headers = _objectSpread2(_objectSpread2({}, HEADERS), options.headers);

  var delParams = body && getRequestParams(options, body);
  var promise = fetch(href(path), {
    body: JSON.stringify(delParams),
    credentials: options.credentials || 'same-origin',
    headers: headers,
    method: 'DELETE'
  });
  return promise.then(function (response) {
    return checkResponseStatus(response).then(function (result) {
      return convertResponseCase(options, result);
    }).then(function (data) {
      return {
        data: data,
        response: response
      };
    });
  });
}
/**
 * Perform an HTTP PATCH to the API and parse the response as JSON
 */

export function patch(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    /** @deprecated */
    convertCase: true,
    convertResponseCase: true,
    convertRequestCase: true
  };

  var headers = _objectSpread2(_objectSpread2({}, HEADERS), options.headers);

  var patchParams = getRequestParams(options, body);
  var promise = fetch(href(path), {
    body: JSON.stringify(patchParams),
    credentials: options.credentials || 'same-origin',
    headers: headers,
    method: 'PATCH'
  });
  return promise.then(function (response) {
    return checkResponseStatus(response).then(function (result) {
      return convertResponseCase(options, result);
    }).then(function (data) {
      return {
        data: data,
        response: response
      };
    });
  });
}
export default {
  serialize: serialize,
  get: get,
  post: post,
  put: put,
  del: del,
  patch: patch
};